import { useTranslation } from 'react-i18next';

import type { MyProfile } from '../api/my-profile.types';
import { formatProfileDate } from '../utils/format-date';
import { MyProfileReadonlyField } from './MyProfileReadonlyField';
import { MyProfileRoleBadges } from './MyProfileRoleBadges';
import { PhoneChangeSection } from './PhoneChangeSection';

interface MyProfileInfoCardProps {
  profile: MyProfile;
}

// PRD 20 §2.1 Card 1 — read-only block + phone-change inline area on the Phone row.
export function MyProfileInfoCard({ profile }: MyProfileInfoCardProps) {
  const { t } = useTranslation('my-profile');

  return (
    <section className="card" style={{ padding: 24 }} aria-labelledby="mp-info-heading">
      <h2 id="mp-info-heading" className="sr-only">
        {t('cards.info.title')}
      </h2>
      <MyProfileReadonlyField
        label={t('cards.info.fields.email')}
        value={profile.email}
      />
      <MyProfileReadonlyField
        label={t('cards.info.fields.name')}
        value={profile.name}
      />
      <PhoneChangeSection currentPhone={profile.phone} />
      <MyProfileReadonlyField
        label={t('cards.info.fields.institution')}
        value={profile.institution}
      />
      <MyProfileReadonlyField label={t('cards.info.fields.role')}>
        <MyProfileRoleBadges roles={profile.roles} isRoot={profile.isRoot} />
      </MyProfileReadonlyField>
      <MyProfileReadonlyField
        label={t('cards.info.fields.joinedAt')}
        value={formatProfileDate(profile.joinedAt)}
      />
    </section>
  );
}
